export function Backdrop({ image, strength = "strong" }) {
  if (!image) return null;
  const overlay = strength === "strong"
    ? "bg-[linear-gradient(100deg,rgba(12,23,38,0.96)_0%,rgba(20,38,61,0.88)_45%,rgba(20,38,61,0.6)_100%)]"
    : "bg-[linear-gradient(100deg,rgba(12,23,38,0.92)_0%,rgba(20,38,61,0.75)_55%,rgba(20,38,61,0.45)_100%)]";
  return (
    <div className="absolute inset-0 -z-10" aria-hidden="true">
      <img src={image} alt="" className="h-full w-full object-cover" loading="eager" />
      <div className={`absolute inset-0 ${overlay}`} />
    </div>
  );
}

export default function PageHero({ eyebrow, title, intro, testid, image }) {
  return (
    <section className="relative isolate overflow-hidden bg-[#14263D] text-white" data-testid={testid}>
      <Backdrop image={image} />
      <div className="absolute inset-0 -z-10 site-lines opacity-60" aria-hidden="true" />
      <div className="max-w-7xl mx-auto px-6 lg:px-10 pt-24 pb-24 lg:pt-32 lg:pb-28 site-reveal">
        <div className="site-eyebrow">{eyebrow}</div>
        <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl font-semibold mt-5 max-w-3xl leading-[1.05]">{title}</h1>
        {intro && <p className="mt-8 text-base md:text-lg text-white/75 max-w-2xl leading-relaxed">{intro}</p>}
      </div>
    </section>
  );
}
